import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-b border-[var(--line)] bg-[var(--bg-alt)] py-16 sm:py-20" data-id="element-61" data-mp="1bmlmp7radxkh">
      <div className="mx-auto max-w-3xl px-4" data-id="element-62" data-mp="1gjvid559r5gr">
        <SectionHeading eyebrow="❓ Lo que más nos preguntan" data-id="element-63" data-mp="248o8gkz7mj3g">
          Preguntas frecuentes
        </SectionHeading>

        <div className="mt-10 space-y-3" data-id="element-64" data-mp="289qa18gln78l">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} className="overflow-hidden rounded-xl border border-[var(--line)] bg-[var(--surface)]" data-id="element-65" data-mp="1uhac2m2k1zej" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 p-5 text-left transition-colors duration-150 ease-out hover:bg-[var(--surface-2)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--rose)]/40" data-id="element-66" data-mp="2n6hall20eozs">
                  <span className="font-semibold text-[var(--text)]" data-id="element-67" data-mp="1emenoon0w1sz">
                    {faq.question}
                  </span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-[var(--rose)]" aria-hidden="true" data-id="element-68" data-mp="1oii0cofi3iu6" /> : <PlusIcon className="h-5 w-5 shrink-0 text-[var(--rose)]" aria-hidden="true" data-id="element-69" data-mp="1xkhhdgqimmx4" />}
                </button>
                {isOpen && <p className="px-5 pb-5 text-[var(--text)]/80" data-id="element-70" data-mp="36gkh1ej09zo">{faq.answer}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}